<template>
    <div class="container_page">
        <a-form layout="inline" style="margin-bottom: 10px">
            <a-form-item label="关键字">
                <a-input placeholder="评价角色名称/评价内容" v-model="filterData.keywords"/>
            </a-form-item>
            <a-form-item label="时间范围">
                <!-- @change="onChangeDate" -->
                <a-range-picker v-model="filterData.timeDate" class="mr12"/>
            </a-form-item>
            <a-form-item>
                <a-button icon="search" class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
                <a-button class="mr12" @click="toSearch(false)">重置</a-button>
                <a-button icon="plus" type="primary" v-if="lang === 'CH'" @click="toAdd">新建评价</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
                 :loading="loading">
            <template slot="businessLogoRender" slot-scope="text, record">
                <viewer :images="[record.businessLogo]">
                    <div class="er_content">
                        <img class="er_content_img" :src="img" v-for="(img,index) in [record.businessLogo]"
                             :key="index">
                    </div>
                </viewer>
            </template>
            <!-- 排序 -->
            <template slot="sortRender" slot-scope="text, record">
                <a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
                         @keyup.enter="handleSaveSort(record)"/>
            </template>

            <template slot="businessStatusRender" slot-scope="text, record">
                <div style="display: flex;align-items: center;">
                    <a-switch :checked="!!record.commentStatus"
                              @change="(checked) => handlePublishChange(checked, record)"/>
                    <a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.commentStatus == true">
                        启用
                    </a-tag>
                    <a-tag style="margin-left: 10px;" v-else-if="record.commentStatus == false">
                        禁用
                    </a-tag>
                    <a-tag style="margin-left: 10px;" v-else></a-tag>
                </div>
            </template>

            <template slot="action" slot-scope="text, record">
                <span><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
                    <a-button type="link" v-if="lang === 'CH'">删除</a-button>
                </a-popconfirm>
            </template>
        </a-table>
        <a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @cancel="editModel.flag = false"
                 :footer="true" :bodyStyle="{ padding: '12px 24px' }">
            <a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
                <!-- 工厂 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label="`${ifFacOrBr=='1'?'工厂':'品牌'}`" prop="businessName">
                            <div>{{initialData.businessName}}</div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- 头像 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="头像">
                            <div style="display: flex;align-items: center;">
                                <div v-if="editModel.avatar">
                                    <viewer :images="[editModel.avatar]">
                                        <div class="er_content">
                                            <img class="er_content_img" :src="img"
                                                 v-for="(img,index) in [editModel.avatar]" :key="index">
                                        </div>
                                    </viewer>
                                </div>
                                <div class="again_upload_box ml12">
                                    <a-spin :spinning="uploadingAvatar" size="small">
                                    <input type="file" accept="image/*" @change="handleUploadThumbnail" :disabled="uploadingAvatar"/>
                                    <i class="el-icon-box again_upload_icon"></i>
                                    <div class="bold" style="width: 100px">
                                        {{ editModel.avatar ? "重新上传" : "上传头像" }}
                                    </div>
                                    </a-spin>
                                </div>
                            </div>
							<div>只能上传jpg/png格式文件，文件不能超过3M</div>
						</a-form-model-item>
                    </a-col>
                </a-row>
                <!-- v-if="ifFacOrBr=='1'" -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="昵称" prop="nickname">
                            <a-input style="width:300px;" placeholder="请输入昵称" v-model="editModel.nickname"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <!-- 评价身份标签 在标签管理中维护 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="评价身份标签" prop="businessName">
                            <a-select style="width:300px;" v-model="editModel.tagId" class="mr12" placeholder="请选择评价身份标签" show-search
                                      option-filter-prop="name" :filter-option="filterOption">
                                <a-select-option v-for="(item, index) of pingjiaList" :key="index" :value="item.tagId">
                                    {{ item.tagName }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- 时间 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="时间" prop="setTime">
                            <a-date-picker v-model="editModel.setTime" format="YYYY-MM-DD"
                                           valueFormat="YYYY-MM-DD"/>
                            <div style="margin-top: 8px;">
                                <a-checkbox v-model="editModel.setStatus">显示设置时间（非必选，若勾选则前端显示设置时间，若不填前端显示发布时间）</a-checkbox>
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- 评价内容 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="评价内容" prop="comment">
                            <a-textarea placeholder="请输入评价内容"                 :maxlength="1000"
                                        v-model="editModel.comment"/>
                            <div style="text-align: right; color: #999; font-size: 12px; margin-top: 4px;">
                                {{ editModel.comment ? editModel.comment.length : 0 }}/1000
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- 图片 -->
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="图片">
                            <div style="display: flex;align-items: center;">
                                <div v-if="editModel.commentImagesList && editModel.commentImagesList.length > 0">
                                    <viewer :images="editModel.commentImagesList">
                                        <div class="er_content">
                                            <!-- 循环图片 + 右上角删除按钮 -->
                                            <div class="image-wrapper"
                                                 v-for="(img,index) in editModel.commentImagesList" :key="index"
                                                 style="position: relative;display: inline-block;margin: 5px;">
                                                <img class="er_content_img" :src="img" style="display: block;">
                                                <!-- 删除按钮 -->
                                                <div class="delete-btn" @click.stop="handleDeleteImage(index)">
                                                    ×
                                                </div>
                                            </div>
                                        </div>
                                    </viewer>
                                </div>
                                <div class="again_upload_box ml12">
                                    <a-spin :spinning="uploadingImage" size="small">
                                    <input type="file" accept="image/*" multiple @change="handleUpdataFile" :disabled="uploadingImage"/>
                                    <i class="el-icon-box again_upload_icon"></i>
                                    <div class="bold" style="width: 100px">
                                        {{ editModel.businessLogo ? "重新上传" : "上传图片" }}
                                    </div>
                                    </a-spin>
                                </div>
                            </div>
							<div>只能上传jpg/png格式文件，文件不能超过3M，不超过9张图片</div>

						</a-form-model-item>
                    </a-col>
                </a-row>


                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="链接地址" prop="urlName">
                            <a-input placeholder="显示文案" style="width: 180px;" v-model="editModel.urlName"/>
                            <a-input placeholder="请输入链接地址" style="width: 280px;" v-model="editModel.url"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24" style="display: flex;align-items: center;justify-content: center;">
                        <!-- <a-button @click="editModel.flag = false">取消</a-button> -->
                        <!-- @click="handleSave(false)" -->
                        <a-button @click="sureEdit('1')" type="primary">保存</a-button>
                        <!-- @click="handleSave(true)" -->
                        <a-button @click="sureEdit('2')" style="margin-left: 20px;" type="primary">保存并发布</a-button>
                    </a-col>
                </a-row>
            </a-form-model>

        </a-modal>
    </div>
</template>

<script>
    import {
        getFactoryCommentsApi, //列表
        getFactoryCommentDetailApi, //详情  不知道从哪里点进去详情
        saveFactoryCommentApi, //编辑
        deleteFactoryCommentApi, //删除
        updateFactoryCommentSortApi,
        updateFactoryCommentStatusApi,
    } from "../../../api/index";
    import {
        ossUpload
    } from "../../../utils/oss";

    export default {
        name: "MainProductTab",
        props: {
            ifFacOrBr: {
                type: String,
                default: ""
            },
            initialData: Object,
            pingjiaList: { // 工艺（工厂）
                type: Array,
                default: () => []
            },
            lang: {
                type: String,
                default: 'CH'
            }
        },
        data() {
            return {
                List: [{
                    value: "1",
                    label: "1111"
                }],
				uploadingAvatar:false,
				uploadingImage:false,
                activeTab: 'FACTORY',
                columns: [{
                    title: 'ID',
                    dataIndex: 'reputationCode',
                    key: 'reputationCode', //
					width: 140
                },
                    {
                        title: '名称（评价者）',
                        dataIndex: 'nickname',
                        key: 'nickname',
						width: 110
					},
                    {
                        title: '角色标签',
                        dataIndex: 'tagName',
                        key: 'tagName',
						width: 110

					},
                    {
                        title: '评价',
                        dataIndex: 'comment',
                        key: 'comment',
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'createTime',
                        key: 'createTime',
						width: 110

					},
                    {
                        title: '状态',
                        dataIndex: 'productStatus',
                        key: 'productStatus',
                        scopedSlots: {
                            customRender: "businessStatusRender"
                        },
						width: 110

					},
                    {
                        title: '排序',
                        dataIndex: 'sort',
                        key: 'sort',
                        scopedSlots: {
                            customRender: "sortRender"
                        },
						width: 110

					},
                    {
                        title: '操作',
                        key: 'action',
                        scopedSlots: {
                            customRender: 'action'
                        },
						width: 150

					}
                ],
                tableData: [],
                pageInfo: {
                    pageSize: 10,
                    current: 1,
                    total: 0,
                    showTotal: (total, range) => {
                        return `合计 ${total} 条记录`;
                    },
                },
                loading: false,
                imgModel: {
                    flag: false,
                    url: "",
                },
                tipsModel: {
                    flag: false,
                    title: "",
                    content: "",
                    giftCardId: 0,
                    giftCardStatus: undefined,
                    onOk: () => {
                    },
                },
                editModel: {
                    flag: false,
                    title: "",
                    commentId: 0,
                    "avatar": "", //头像
                    "nickname": "", //昵称
                    "tagId": undefined, //品类ID
                    "comment": "", //评价
                    "commentStatus": false, //发布状态
                    "setStatus": false, //显示设置时间
                    "setTime": "", //设置时间
                    "commentImages": "", //图片 多个;隔开
                    "commentImagesList": [],
                    "urlName": "", //链接地址显示文案
                    "url": "", //URL
                    onOk: () => {
                    },
                },
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 18
                },
                filterData: {
                    timeDate: [],
                    keywords: "",
                },
            };
        },
        created() {
        },
        activated() {
        },
        watch: {
            'initialData.businessLangId'(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.getData(1);
                }
            }
        },
        mounted() {
            // const storedQuery = localStorage.getItem('fctory_band_spplierManage_searchQuery');
            // if (storedQuery) {
            // 	this.filterData = JSON.parse(storedQuery);
            // } else {}
            if (this.initialData && this.initialData.businessLangId) {
                this.getData(1);
            }
        },
        beforeRouteLeave(to, from, next) {
            // localStorage.setItem('fctory_band_spplierManage_searchQuery', JSON.stringify(this.filterData));
            // next();
        },
        methods: {
            handlePublishChange(checked, record) {
                // 动态生成提示文案
                let content = '';
                if (checked) {
                    // 切换为 启用
                    content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
                } else {
                    // 切换为 禁用
                    content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
                }
                this.$confirm({
                    title: '操作确认',
                    content: content,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        // 确认后执行的操作
                        record.commentStatus = checked ? 1 : 0; // 接口需要数字，存回数字
                        // 这里可以调用接口更新状态
                        this.updateStatusApi(record.commentId)
                    },
                    onCancel: () => {
                    }
                });
            },
            updateStatusApi(commentId) {
                updateFactoryCommentStatusApi({
                    commentId: commentId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                "修改成功"
                            );
                            this.editModel.flag = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                    })
                    .finally(() => {
                        this.getData(this.pageInfo.current)
                    })
            },
            // 保存排序（输入框回车/失焦触发）
            handleSaveSort(record) {
                // 排序号为空不提交
                if (record.sort === undefined || record.sort === null || record.sort === '') {
                    return
                }
                // 调用你已有的排序接口
                updateFactoryCommentSortApi({
                    commentId: record.commentId,
                    sort: record.sort
                }).then(res => {
                    if (res.resultStatus) {
                        this.$message.success('排序保存成功')
                        this.getData(this.pageInfo.current) // 刷新列表，实现重排
                    } else {
                        this.$message.error('保存失败')
                    }
                }).catch(err => {
                    this.$message.error('保存失败')
                })
            },

            onTabChange(key) {
                console.log('Tab changed to:', key);
                this.activeTab = key;
                // 如果是接口请求数据，可以在这里调用接口
                this.getData(1);
            },
            changeTab(value) {
                console.log('Tab changed to:', value);
                this.filterData.businessType = value.target.value;
                this.getData();
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },

            changePage(page) {
                this.pageInfo.current = page.current;
                this.getData(this.pageInfo.current);
            },
            toSearch(flag) {
                if (flag) {
                    this.getData(1);
                } else {
                    this.filterData = {
                        timeDate: [],
                        keywords: "",
                    };
                    this.getData(1);
                }
            },
            getData(page = 1) {
                const factoryLangId = this.initialData && this.initialData.businessLangId;
                if (!factoryLangId) {
                    this.tableData = [];
                    this.pageInfo.total = 0;
                    return;
                }
                this.pageInfo.current = page;
                if (this.loading) {
                    return;
                }
                this.loading = true;
                getFactoryCommentsApi({
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    startDate: this.filterData.timeDate.length === 2 ?
                        this.$moment(this.filterData.timeDate[0]).format(
                            "YYYY-MM-DD"
                        ) : null,
                    endDate: this.filterData.timeDate.length === 2 ?
                        this.$moment(this.filterData.timeDate[1]).format(
                            "YYYY-MM-DD"
                        ) : null,
                    keywords: this.filterData.keywords, //产品名称
                    factoryLangId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = res.resultData.dataList || [];
                            this.pageInfo.total = res.resultData.totalNum || 0;

                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toAdd() {
                this.editModel = {
                    flag: true,
                    title: "新建社会评价",
                    commentId: 0,
                    "avatar": "", //头像
                    "nickname": "", //昵称
                    "tagId": undefined, //品类ID
                    "comment": "", //评价
                    "commentStatus": false, //发布状态
                    "setStatus": false, //显示设置时间
                    "setTime": "", //设置时间
                    "commentImages": "", //图片 多个;隔开
                    "commentImagesList": [],
                    "urlName": "", //链接地址显示文案
                    "url": "", //URL
                    onOk: this.sureEdit,
                };
            },
            toEdit(data) {
                getFactoryCommentDetailApi({
                    commentId: data.commentId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            const result = res.resultData;
                            this.editModel = {
                                "flag": true,
                                "title": "编辑社会评价",
                                "commentId": result.commentId,
                                "reputationCode": result.reputationCode,
                                "avatar": result.avatar, //头像
                                "nickname": result.nickname, //昵称
                                "tagId": result.tagId, //品类ID
                                "tagName": result.tagName, //品类名称
                                "comment": result.comment, //评价
                                "commentStatus": result.commentStatus, //发布状态
                                "sort": result.sort, //排序序号
                                "setStatus": result.setStatus, //显示设置时间
                                "setTime": result.setTime, //设置时间
                                "createTime": result.createTime, //创建时间
                                "commentImages": result.commentImages, //图片 多个;隔开
                                "commentImagesList": result.commentImages ? result.commentImages.split(';').filter(item => item) : [],
                                "urlName": result.urlName, //链接地址显示文案
                                "url": result.url, //URL
                                // onOk: this.sureEdit,
                            };
                        } else {
                            console.log("res");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            // 编辑
            sureEdit(flag) {
                // 链接地址格式校验：若填写了链接，必须以 http:// 或 https:// 开头
                const linkUrl = (this.editModel.url || '').trim();
                if (linkUrl && !/^https?:\/\/.+/.test(linkUrl)) {
                    this.$message.warning('请填写正确的链接地址（以 http:// 或 https:// 开头）');
                    return;
                }
                let params = {
                    "commentId": this.editModel.commentId,
                    "avatar": this.editModel.avatar, //头像
                    "nickname": this.editModel.nickname, //昵称
                    "tagId": this.editModel.tagId, //品类ID
                    "comment": this.editModel.comment, //评价
                    "commentStatus": flag == '1' ? false : flag == '2' ? true : "", //发布状态
                    "setStatus": this.editModel.setStatus, //显示设置时间
                    "commentImages": this.editModel.commentImagesList.join(';'), //图片 多个;隔开
                    "setTime": this.editModel.setTime, //设置时间
                    "urlName": this.editModel.urlName, //链接地址显示文案
                    "url": this.editModel.url, //URL
                    "factoryLangId": this.initialData.businessLangId, //工厂/品牌 语言ID
                }
                saveFactoryCommentApi(params)
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                this.editModel.commentId ? "编辑成功" : "新增成功"
                            );
                            this.editModel.flag = false;
                        } else {
                            this.editModel.flag = false;
                            console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        this.editModel.flag = false;
                        console.log(error);
                    })
                    .finally(() => {
                        this.getData(this.pageInfo.current)
                    })
            },
            toSeeImg(data) {
                this.imgModel = {
                    flag: true,
                    url: data.iconUrl,
                };
            },
            sureDelete(record) {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                deleteFactoryCommentApi({
                    commentId: record.commentId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success("删除成功");
                            this.tipsModel.flag = false;
                        } else {
                            console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.getData(this.pageInfo.current);
                    });
            },

            // 删除图片
            handleDeleteImage(index) {
                // 根据索引删除对应图片
                this.editModel.commentImagesList.splice(index, 1);
                this.$message.success('删除成功');
            },
            handleUploadThumbnail(e) {
                if (!e.target.files.length) return;
                const file = e.target.files[0];
                if (file.size > 3 * 1024 * 1024) { this.$message.error('图片不能超过3MB'); return; }
                this.uploadingAvatar = true;
                ossUpload(file, '', 'image/').then((res) => {
                    this.editModel.avatar = res.url;
                }).catch(() => {
                    this.$message.error('图片上传失败');
                }).finally(() => {
                    this.uploadingAvatar = false;
                })
            },
            // 上传文件（多图，最多50张，每张≤3MB）
            handleUpdataFile(e) {
                const files = Array.from(e.target.files || []);
                if (!files.length) return;
                const currentCount = (this.editModel.commentImagesList || []).length;
                const maxCanAdd = 50 - currentCount;
                if (files.length > maxCanAdd) {
                    this.$message.warning('只能再选 ' + maxCanAdd + ' 张，已自动截取前 ' + maxCanAdd + ' 张');
                }
                const toUpload = files.slice(0, maxCanAdd);
                for (const f of toUpload) {
                    if (f.size > 3 * 1024 * 1024) {
                        this.$message.error(f.name + ' 超过3MB限制');
                        e.target.value = '';
                        return;
                    }
                }
                this.uploadingImage = true;
                const uploads = toUpload.map(f => ossUpload(f, '', 'image/'));
                Promise.all(uploads).then(results => {
                    if (!this.editModel.commentImagesList) this.editModel.commentImagesList = [];
                    results.forEach(r => this.editModel.commentImagesList.push(r.url));
                    this.$message.success('图片上传成功');
                }).catch(() => {
                    this.$message.error('图片上传失败');
                }).finally(() => {
                    this.uploadingImage = false;
                })
                e.target.value = '';
            },
        },
    };
</script>

<style lang="less" scoped>
    .container_page {
        padding: 20px;
        background: #ffffff;

        .cate {
            margin: 20px 0;

            .ant-radio-button-wrapper {
                width: 100px !important;
                text-align: center !important;
            }
        }

        .mr12 {
            margin-right: 12px;
        }
    }

    /* 图片删除按钮样式 */
    .delete-btn {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background-color: #ff4444;
        color: white;
        border-radius: 50%;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        z-index: 10;
    }

    .delete-btn:hover {
        background-color: #ff0000;
    }
</style>
